import React, { useEffect, useState } from 'react';
import { useFileApi } from '../../hooks/useFileApi';

interface ImagePreviewProps {
  fileId?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xlg' | 'hlg' | 'fll';
  objectFit?: 'cover' | 'contain';
}

const ImagePreview: React.FC<ImagePreviewProps> = ({
  fileId,
  size = 'sm',
  objectFit = 'cover'
}) => {
  const [imageUrl, setImageUrl] = useState<string>('');
  const { getFileUrl } = useFileApi();

  const sizeClasses = {
    xs: 'w-7 h-7',
    sm: 'w-12 h-12',
    md: 'w-20 h-20',
    lg: 'w-32 h-32',
    xlg: 'w-100 h-100',
    hlg: 'h-40',
    fll: 'w-full h-full',
  };

  const [status, setStatus] = useState<string>('');

  useEffect(() => {
    const loadImageUrl = async () => {
      if (fileId) {
        try {
          const response = await getFileUrl(fileId);
          if (response.success && response.data) {
            setStatus(response.data.status ?? '');
            if (response.data.status === 'Processed') {
              setImageUrl(response.data.url ?? '');
            }
          }
        } catch (error) {
          console.error('Error loading image:', error);
        }
      }
    };

    loadImageUrl();
  }, [fileId]);

  if (!fileId) return null;

  return (
    <div className={`${sizeClasses[size]} rounded-md overflow-hidden`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="Preview"
          className={`w-full h-full ${objectFit === 'contain' ? 'object-contain' : 'object-cover'}`}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gray-100">
          <span className="text-gray-400 text-xs">{status && status !== 'Processed' ? 'Processing...' : 'Loading...'}</span>
        </div>
      )}
    </div>
  );
};

export default ImagePreview;